// 日本語翻訳ファイル
export const ja = {
  // 共通
  common: {
    close: 'とじる',
    save: '保存',
    cancel: 'キャンセル',
    yes: 'はい',
    no: 'いいえ',
    minutes: '分',
    hours: '時間',
    days: '日',
    donuts: 'ドーナツ',
  },

  // タイマー
  timer: {
    work: '作業',
    break: '休憩',
    start: 'スタート',
    stop: 'ストップ',
    sessionComplete: 'セッション完了！',
  },

  // メニュー
  menu: {
    timerSettings: 'タイマー設定',
    audioSettings: '音量設定',
    systemSettings: 'システム設定',
    restSettings: '目標設定',
    stats: '統計',
    appInfo: 'アプリ情報',
  },

  // ツールボタン
  tools: {
    stats: '統計',
    dress: '着せ替え',
    camera: 'カメラ',
    bgm: 'BGM',
  },

  // 設定
  settings: {
    workDuration: '作業時間',
    breakDuration: '休憩時間',
    autoStart: '自動開始',
    bgmVolume: 'BGM音量',
    seVolume: 'SE音量',
    weatherEnabled: '天気表示',
    language: '言語',
  },

  // 統計
  stats: {
    todayWorkTime: '今日の作業時間',
    totalWorkTime: '累計作業時間',
    currentStreak: '現在のストリーク',
    longestStreak: '最長ストリーク',
    level: 'レベル',
    totalDonuts: '累計ドーナツ',
  },

  // メッセージ（空ちゃん）
  messages: {
    // 朝の挨拶
    morningGreeting: [
      'おはよう！今日もがんばろうね',
      'おはよう！よく寝れた？',
      'おはよう！今日はどんな一日にする？',
    ],
    // 褒める
    praise: [
      'えらい！',
      'すごい！',
      'がんばったね！',
      'お疲れさま！',
    ],
    // 励ます
    encourage: [
      '無理しないでね',
      '1分でもえらいよ',
      'ゆっくりでいいよ',
      '休むのも大事だよ',
    ],
    // 天気
    weatherSunny: '今日はいい天気だね！でも無理しないで',
    weatherRainy: '雨の日はゆっくりでいいよ',
    weatherCloudy: '曇りの日は気分も曇りがち。無理しないでね',
  },

  // アプリ情報
  appInfo: {
    version: 'バージョン',
    developer: '開発者',
    concept: 'コンセプト',
    antiProductivity: '世界初の反生産性ポモドーロアプリ',
    philosophy: '生産性より、心の健康を',
  },
};